
<context-display :context="context">
  <template #simple>
    <p v-html="displayHtml"></p>
  </template>
  <template #workarea>
    <span v-html="displayHtml"></span>
  </template>
</context-display>
